import Joi from 'joi';
const spacingBlockSchema = Joi.object({
  type: Joi.string().valid('spacingBlock').required(),
  code: Joi.string().allow('', null).required(),
  backgroundColor: Joi.string().allow('', null).required(),
  height: Joi.string().allow(null)
}).unknown(true);
export default spacingBlockSchema;